const APP_EVENTS = {
  ONBOARDING_TOUR_COMPLETED: "onboarding-tour-completed",
  PWA_INSTALLATION_SHOWN: "pwa-installation-shown",
} as const;
type AppEvent = (typeof APP_EVENTS)[keyof typeof APP_EVENTS];

export { APP_EVENTS };
export type { AppEvent };
